module.exports = __webpack_public_path__ + "img/Slice5-min.99c86b7e.png";